// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"Download_downloadButton__21gwK"};